<template>
  <div class="business_tabs">
    <a-tabs type="card">
      <a-tab-pane key="1" tab="巡检信息">
        <inspection-information ref="inspectionInformation" :model="model"></inspection-information>
      </a-tab-pane>
      <a-tab-pane key="2" tab="维修信息">
        <repair-information ref="repairInformation" :model="model"></repair-information>
      </a-tab-pane>
      <a-tab-pane key="3" tab="保养信息">
        <maintenance-information ref="maintenanceInformation" :model="model"></maintenance-information>
      </a-tab-pane>
      <a-tab-pane key="4" tab="定检信息">
        <qualification-information ref="qualificationInformation" :model="model"></qualification-information>
      </a-tab-pane>
      <a-tab-pane key="5" tab="费用信息">
        <expense ref="expense" :model="model"></expense>
      </a-tab-pane>
    </a-tabs>
  </div>
</template>

<script>
import inspectionInformation from './inspectionInformation'
import biographicalInformation from './biographicalInformation'
import repairInformation from './repairInformation'
import maintenanceInformation from './maintenanceInformation'
import qualificationInformation from './qualificationInformation'
import Expense from './expense.vue'
export default {
  props: {
    model: Object
  },
  components: {
    inspectionInformation,
    biographicalInformation,
    repairInformation,
    maintenanceInformation,
    qualificationInformation,
    Expense
  },
  data () {
    return {
    }
  },
  methods: {
  }
}
</script>

<style lang="less" scoped>
.business_tabs {
  // /deep/.ant-tabs-bar .ant-tabs-nav-container .ant-tabs-tab-active {
  //   background: rgba(255, 255, 255, 1) !important;
  //   font-size: 12px;
  //   color: #08409f !important;
  //   font-family: SourceHanSansCN-Bold, SourceHanSansCN;
  //   font-weight: bold;
  // }
  // /deep/.ant-tabs-bar .ant-tabs-nav-container .ant-tabs-tab {
  //   background: rgba(255, 255, 255, 1) !important;
  //   font-size: 12px;
  //   color: #b3b3b3;
  //   line-height: 18px;
  //   font-family: SourceHanSansCN-Bold, SourceHanSansCN;
  //   font-weight: bold;
  // }
  /deep/.ant-tabs-bar {
    border: 0;
    margin-bottom: 0;
    .ant-tabs-nav-container {
      border-bottom: 1px solid #e8e8e8;

      .ant-tabs-tab {
        border: 0;
        height: 26px;
        // line-height: 26px;
        padding: 0 10px;
        margin: 7px 0;
        margin-right: 16px;

        background: rgba(255, 255, 255, 1) !important;
        font-size: 12px;
        color: #b3b3b3;
        line-height: 18px;
        font-family: SourceHanSansCN-Bold, SourceHanSansCN;
        font-weight: bold;
      }
      .ant-tabs-tab-active {
        background: rgba(255, 255, 255, 1) !important;
        font-size: 12px;
        color: #08409f !important;
        font-family: SourceHanSansCN-Bold, SourceHanSansCN;
        font-weight: bold;
      }
    }
  }
  /deep/.ant-tabs-content {
    .ant-tabs-tabpane{
      >div{
        margin-left: -1px;
        margin-right: -1px;
        margin-bottom: -1px;
      }
    }
  }
  /deep/ .table {
    .ant-table-thead {
      > tr {
        > th {
          background: rgba(8, 64, 159, 0.1);
          border-right: 1px solid #dddddd;

          .ant-table-header-column {
            font-size: 12px;
            font-family: SourceHanSansCN-Normal, SourceHanSansCN;
            font-weight: 400;
            color: #333333;
            line-height: 18px;
          }
        }
      }
    }
  }
  // /deep/.ant-tabs-tab{
  //   border: 0 !important;
  //   height: 26px !important;
  //   line-height: 26px !important;
  //   padding: 0 10px !important;
  //   margin: 7px 0 !important;
  //   margin-right: 16px !important;
  // }
  // /deep/.ant-tabs-tab-active{
  //   background: rgba(23, 145, 255, 0.1) !important;
  // }
}
</style>
